import script from "./Device.vue?vue&type=script&setup=true&lang=js"
export * from "./Device.vue?vue&type=script&setup=true&lang=js"

import "./Device.vue?vue&type=style&index=0&id=2be84d0e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be84d0e"]])

export default __exports__